<div class="not-supported-container">
  <h3 class="header">
    You are seeing this page because you are using a unsupported browser. Currently we support the following browsers:
  </h3>
  <div class="browsers-container">
    <a href="https://www.google.com/chrome/">
      <img
        src="/assets/chrome.png"
        alt="Chrome logo"
      />
    </a>
    <a href="https://www.mozilla.org/en-US/firefox/new/">
      <img
        src="/assets/firefox.jpg"
        alt="Firefox logo"
      />
    </a>
    <a href="https://www.apple.com/safari/">
      <img
        src="/assets/safari.png"
        alt="Safari logo"
      />
    </a>
  </div>
  <a
    class="back-link"
    href="/"
  >
    Go to home page
  </a>
</div>
